import * as React from "react";
import classnames from "classnames";
import { Autocomplete, Button } from "@grandvisionhq/common";
import { Icon } from "@grandvisionhq/icons";
import MyCurrentLocation from "../../MyCurrentLocation/components/StoreSearchForm/MyCurrentLocation/MyCurrentLocation.js";
/* empty css                     */
const StoreSearchForm = ({
  className,
  labels,
  loading,
  showClearButton,
  searchQuery,
  suggestions,
  searchRef,
  onChange,
  onSubmit,
  onClear,
  onSuggestionClick,
  onUseMyCurrentLocationClick,
  isFocusedOnMount,
  isSuggestionSelected,
  isUsingUserLocation,
  minSearchCharacterCount,
  onSuggestionTopContentClick,
  queryResultsFilters,
  ...rest
}) => {
  const autoCompleteLabels = React.useMemo(
    () => ({
      placeholder: labels.placeholder,
      noResults: labels.noResults,
      noAvailableResultsScreenReaderHint: labels.noAvailableResultsScreenReaderHint
    }),
    [labels]
  );
  return /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("store-search-field-stores-v2", className) }, /* @__PURE__ */ React.createElement("div", { className: "store-search-field-stores-v2__search-form" }, /* @__PURE__ */ React.createElement(
    "form",
    {
      role: "search",
      action: "",
      onSubmit: (event) => {
        event && event.preventDefault();
        onSubmit();
      }
    },
    /* @__PURE__ */ React.createElement(
      Autocomplete,
      {
        className: classnames({
          "store-search-field-stores-v2__search-form--with-user--location": isUsingUserLocation
        }),
        inputRef: searchRef,
        name: "store-search",
        type: "search",
        labels: autoCompleteLabels,
        isFocusedOnMount,
        loading,
        value: searchQuery,
        showClearButton,
        submitIcon: /* @__PURE__ */ React.createElement(Icon, { name: "search" }),
        minCountCharactersToSubmit: minSearchCharacterCount,
        isSuggestionSelected,
        suggestionTopContent: !isUsingUserLocation ? /* @__PURE__ */ React.createElement(MyCurrentLocation, { label: labels.useMyCurrentLocation }) : void 0,
        suggestions,
        inputDataT: "search",
        onChange,
        onSubmit,
        onClear,
        onSuggestionClick,
        onSuggestionTopContentClick,
        disabled: isUsingUserLocation
      }
    )
  ), !isUsingUserLocation && /* @__PURE__ */ React.createElement(
    Button,
    {
      variant: "outline",
      icon: "gps",
      caption: labels.useMyCurrentLocation,
      className: "store-search-field-stores-v2__button",
      onClick: onUseMyCurrentLocationClick,
      "data-t": "userLocationBtn"
    }
  )), queryResultsFilters ? /* @__PURE__ */ React.createElement("div", { className: "store-search-field-stores-v2__query-results-filters" }, queryResultsFilters) : null);
};
export {
  StoreSearchForm as default
};
//# sourceMappingURL=StoreSearchForm.js.map
